import log from 'uix/logging'

export const getType = (types, nameOrDatatype, subtype) => {
  let result = null
  let datatype = null
  let internalDatatype = null
  if (subtype !== undefined) {
    if (types[nameOrDatatype]) {
      let dt = types.datatypeMap[nameOrDatatype]
      result = types.byId[dt][subtype]
    } else {
      result = types.byId[nameOrDatatype][subtype]
    }
  } else {
    result = types.byName[nameOrDatatype]
  }

  if (!result) {
    log.error('used types: %o', types)
    throw Error(`no valid type: ${nameOrDatatype} ${subtype}`)
    //~ return {name: 'unknown', internalType: 0, datatypeName: datatype, internalDatatype}
  }
  return result
}

// map typeNames to tree graphics set
export const CUSTOM_TREE_ICONS = {
  wiki_domain_container: 'WebPages',
  '7_1': 'WebPages',
  webresource_domain_container: 'WebResources',
  '7_2': 'WebResources',
  xslt_domain_container: 'Web',
  '7_18': 'Web',
  names_domain_container: 'persons',
  '7_13': 'persons',
  places_domain_container: 'places',
  '7_16': 'places',
  topics_domain_container: 'Topic',
  '7_17': 'Topic',
  subjects_domain_container: 'subjects',
  '7_19': 'subjects',
  deliverer_domain_container: 'HistoryDeliveries',
  '14_1': 'HistoryDeliveries',
  glossary_domain_container: 'subjects',
  '7_24': 'subjects',
}
